import {
  CheckOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  PauseCircleOutlined,
  MinusOutlined,
  StopOutlined,
} from "@ant-design/icons";
import TooltipTag from "../../components/UI/TooltipTag";
import type { ReactNode } from "react";

//Dosing Timepoint mapping
export const iconTypeMap: Record<string, ReactNode> = {
  Administered: <CheckOutlined style={{ color: "#064C68" }} />,
  Increased: <ArrowUpOutlined style={{ color: "#004A42" }} />,
  Reduced: <ArrowDownOutlined style={{ color: "#BE4E01" }} />,
  Missed: <StopOutlined style={{ color: "#73134A" }} />,
  Interrupted: <PauseCircleOutlined style={{ color: "#3F3518" }} />,
  "Not Required": <MinusOutlined style={{ color: "#d5dadc" }} />,
  "Data Pending": (
    <TooltipTag
      tooltipTitle="Data not yet available."
      tagColor="#FEF7DF"
      textColor="#3F3518"
    >
      Data Pending
    </TooltipTag>
  ),
  "Data Missing": (
    <TooltipTag
      tooltipTitle="Expected data not found."
      tagColor="#F2C9AE"
      textColor="#A04000"
    >
      Data Missing
    </TooltipTag>
  ),
  "Data Discrepancy": (
    <TooltipTag
      tooltipTitle="Data mismatch."
      tagColor="#F8CACA"
      textColor="#980000"
    >
      Data Discrepancy
    </TooltipTag>
  ),
};

export const cellStyleMap: Record<string, React.CSSProperties> = {
  Administered: { backgroundColor: "#D2EFF9", color: "#1C1B1F" },
  Increased: { backgroundColor: "#CAE6D6", color: "#73134A" },
  Reduced: { backgroundColor: "#F2C9AE", color: "#DF7934" },
  Missed: { backgroundColor: "#EBD1E0", color: "#73134A" },
  Interrupted: { backgroundColor: "#FEF7DF", color: "#3F3518" },
  "Data Pending": {},
  "Data Missing": {},
  "Data Discrepancy": {},
  "Not Required": { color: "#D5DADC" },
  default: {},
};

//Dosing Status mapping
export const textColor: Record<string, string> = {
  Active: "#283833",
  Complete: "#064C68",
  "Early Termination": "#73134A",
  "Not Enrolled": "#20353E",
  "Data Pending": "#3F3518",
  "Data Missing": "#A04000",
  "Data Discrepancy": "#980000",
};

export const borderColor: Record<string, string> = {
  Active: "#CAE6D6",
  Complete: "#D2EFF9",
  "Early Termination": "#EBD1E0",
  "Not Enrolled": "#D5DADC",
  "Data Pending": "#FEF7DF",
  "Data Missing": "#F2C9AE",
  "Data Discrepancy": "#F8CACA",
};

export const pillColor: Record<string, string> = {
  Active: "#CAE6D6",
  Complete: "#D2EFF9",
  "Early Termination": "#EBD1E0",
  "Not Enrolled": "#D5DADC",
  "Data Pending": "#FEF7DF",
  "Data Missing": "#F2C9AE",
  "Data Discrepancy": "#F8CACA",
};

export const tooltipTitle: Record<string, string> = {
  Active: "Subject is part of a study that is ongoing.",
  Complete: "Subject completed the study.",
  "Early Termination": "Subject discontinued study prior to completion.",
  "Not Enrolled":
    "Subject has not been randomized and is not enrolled in the study.",
  "Data Pending": "Data not yet available.",
  "Data Missing": "Expected data not found.",
  "Data Discrepancy": "Data mismatch.",
};

export const dataStatus: Record<string, string> = {
  "Data Pending": "Data Pending",
  "Data Missing": "Data Missing",
  "Data Discrepancy": "Data Discrepancy",
};
